import React from 'react'
import { getConfigRefCodeValue } from '../../../../../utils/submissions/values'

const FacilityInformation = ({
    formType,
    facilityData,
    continueDisabled,
    viewOnly,
    uploadConfig,
}) => {
    if (
        (continueDisabled && !viewOnly) ||
        !(
            facilityData &&
            facilityData.facility &&
            facilityData.vwEnvFacilityInfo
        )
    ) {
        return null
    }

    const facility = facilityData.facility
    const vwEnvFacilityInfo = facilityData.vwEnvFacilityInfo
    return (
        <div className="form is-centered">
            <div className="is-size-4 has-text-weight-semibold has-text-centered matchingFacilityText">
                Station Information:{' '}
            </div>
            <div className="field is-horizontal">
                <div className="field-label">
                    <label className="label">Waterbody Name: </label>
                </div>
                <div className="field-body">
                    <div className="field">
                        <div className="control is-expanded">
                            <input
                                disabled
                                className="input is-small"
                                value={facility.facilityName}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="field is-horizontal">
                <div className="field-label">
                    <label className="label">Waterbody Type: </label>
                </div>
                <div className="field-body">
                    <div className="field">
                        <div className="control is-expanded">
                            <input
                                disabled
                                className="input is-small"
                                value={getConfigRefCodeValue(
                                    'FacilityType',
                                    facility.facilityType,
                                    uploadConfig
                                )}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="field is-horizontal">
                <div className="field-label">
                    <label className="label">State - County: </label>
                </div>
                <div className="field-body">
                    <div className="field">
                        <div className="control is-expanded">
                            <input
                                disabled
                                className="input is-small"
                                value={vwEnvFacilityInfo.stateCounty}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="field is-horizontal">
                <div className="field-label">
                    <label className="label">Township|Range|Section: </label>
                </div>
                <div className="field-body">
                    <div className="field">
                        <div className="control is-expanded">
                            <input
                                disabled
                                className="input is-small"
                                value={vwEnvFacilityInfo.townshipRangeSection}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="field is-horizontal">
                <div className="field-label">
                    <label className="label">Latitude (NAD83): </label>
                </div>
                <div className="field-body">
                    <div className="field">
                        <div className="control is-expanded">
                            <input
                                disabled
                                className="input is-small"
                                value={facility.latitude83}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="field is-horizontal">
                <div className="field-label">
                    <label className="label">Longitude (NAD83): </label>
                </div>
                <div className="field-body">
                    <div className="field">
                        <div className="control is-expanded">
                            <input
                                disabled
                                className="input is-small"
                                value={facility.longitude83}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="field is-horizontal">
                <div className="field-label">
                    <label className="label">HUC12: </label>
                </div>
                <div className="field-body">
                    <div className="field">
                        <div className="control is-expanded">
                            <input
                                disabled
                                className="input is-small"
                                value={vwEnvFacilityInfo.huc12}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FacilityInformation
